<template>
  <div class="feedback">
    <!-- Успех/Ошибка -->
    <b-container class="my-5 text-center" v-if="!formToggle">

      <!-- Ошибка -->
      <div v-if="formResponseError">
        <div class="text-center my-5">
          <p class="h3">
            Произошла ошибка
          </p>
        </div>
        <div class="d-flex justify-content-center my-5">
          <font-awesome-icon icon="times"
                             size="6x"
                             :style="{ color: 'red' }" />
        </div>
        <div class="text-center my-5">
          <b-button variant="success"
                    @click="goToForm()"
          >
            Попробовать еще раз
          </b-button>
        </div>
      </div>
      <!-- /Ошибка -->

      <!-- Успех -->
      <div v-if="!formResponseError">
        <div class="text-center my-4">
          <p class="h3">
            Запрос успешно отправлен
          </p>
        </div>
        <div class="d-flex justify-content-center my-5">
          <font-awesome-icon icon="check-circle"
                             size="4x"
                             :style="{ color: '#66cc00' }" />
        </div>
        <div class="text-center my-5">
          <b-button variant="success"
                    @click="goToForm()"
          >
            Попробовать еще раз
          </b-button>
        </div>
      </div>
      <!-- /Успех -->
    </b-container>
    <!-- /Успех/Ошибка -->

    <!--Форма-->
    <b-container class="my-5" v-if="formToggle">
      <h3 class="mb-5 text-center">
        Заполните короткую форму и мы с вами свяжемся в течение 15 минут
      </h3>

      <b-form @submit="onSubmit">
        <!--Телефон-->
        <b-col cols="12"
               sm="10"
               md="8"
               lg="6"
               class="mx-auto my-4">
          <label for="input-phone"
          >
            Номер телефона:
          </label>
          <vue-phone-number-input v-model="form.phone"
                                  id="input-phone"
                                  default-country-code="RU"
                                  required
                                  :dark="false"
                                  :disabled="isLoading"
                                  @update="onUpdateVuePhoneNumber" />
        </b-col>

        <!--E-mail-->
        <b-col cols="12"
               sm="10"
               md="8"
               lg="6"
               class="mx-auto my-4">
          <label for="input-email">
            Email:
          </label>
          <b-form-input
              id="input-email"
              v-model="form.email"
              type="email"
              required
              :disabled="isLoading">
          </b-form-input>
        </b-col>

        <!--Ваше имя и фамилия-->
        <b-col cols="12"
               sm="10"
               md="8"
               lg="6"
               class="mx-auto my-4">
          <label for="input-name">
            Ваше имя и фамилия:
          </label>
          <b-form-input
              id="input-name"
              v-model="form.name"
              type="text"
              required
              :disabled="isLoading">
          </b-form-input>
        </b-col>

        <!--Ваш возраст-->
        <b-col cols="12"
               sm="10"
               md="8"
               lg="6"
               class="mx-auto my-4">
          <label for="input-age">
            Ваш возраст:
          </label>
          <b-form-input
              id="input-age"
              v-model="form.age"
              type="text"
              required
              :disabled="isLoading">
          </b-form-input>
        </b-col>

        <!--Ваше гражданство-->
        <b-col cols="12"
               sm="10"
               md="8"
               lg="6"
               class="mx-auto my-4">
          <label for="input-comment">
            Гражданство:
          </label>
          <b-form-input
            id="input-citizenship"
            v-model="form.citizenship"
            type="text"
            required
            :disabled="isLoading">
          </b-form-input>
        </b-col>

        <b-col cols="12"
               sm="10"
               md="8"
               lg="6"
               class="mx-auto my-4 text-center">
          <b-button type="submit"
                    variant="warning"
                    :disabled="isLoading"
          >
            Отправить
          </b-button>
        </b-col>

      </b-form>
    </b-container>
    <!-- /Форма -->
  </div>
</template>

<script>

export default {
  name: 'feedback',
  data () {
    return {
      formToggle: true,
      formResponseError: false,
      form: {
        phone: '9081811995',
        email: 'a@a.ru',
        name: 'Антон',
        age: '24',
        citizenship: 'Ростов',
      },
      formPhoneObject: {}
    }
  },
  mounted: function () {},
  computed: {
    isLoading() {
      return this.$store.getters['isLoading']
    }
  },
  methods: {
    /* Открыть форму снова */
    goToForm() {
      this.formToggle = true
      this.formResponseError = false
    },

    /* Обновить объект с */
    onUpdateVuePhoneNumber(payload) {
      this.formPhoneObject = payload
    },
    onSubmit(evt) {
      let _this = this
      evt.preventDefault()

      if (!this.formPhoneObject.isValid)
        return

      let form = {
        'phone': this.formPhoneObject.formatInternational,
        'email': this.form.email,
        'name': this.form.name,
        'age': this.form.age,
        'citizenship': this.form.citizenship,
      }

      this.$store.dispatch('sendFeedback', form)
        .then(() => {
          _this.formResponseError = false
          _this.formToggle = false
        })
        .catch(() => {
          _this.formResponseError = true
          _this.formToggle = false
        })
    },
  }
}
</script>

<style lang="scss"></style>
